import React from 'react';

import SkeletonTable from '~/components/core/Skeletons/SkeletonTable';
import SortableTable from '~/components/core/Tables/SortableTable';
import { useLobConfiguration } from '~/components/hooks/useLobConfiguration';
import type { PolicyListResponsePolicyListItemModel } from '~/server_shared/openapi/data-contracts';

import { PolicyEmptyState } from './PolicyEmptyState';
import { createPolicyTableColumns } from './PolicyTableColumns';

interface PolicyListProps {
  policies: PolicyListResponsePolicyListItemModel[];
  onView: (policy: PolicyListResponsePolicyListItemModel) => void;
  onEdit: (policy: PolicyListResponsePolicyListItemModel) => void;
  onDelete: (policy: PolicyListResponsePolicyListItemModel) => void;
  policyLoadingNumber?: string | null;
  loading?: boolean;
}

const PolicyList: React.FC<PolicyListProps> = ({
  policies,
  onView,
  onEdit,
  onDelete,
  policyLoadingNumber,
  loading,
}) => {
  const { lobConfigurationsDict } = useLobConfiguration();
  // Show skeleton while loading
  if (loading) {
    return (
      <div className="mt-4">
        <SkeletonTable rowsCount={5} columnsCount={5} maxHeight="600px" />
      </div>
    );
  }

  // Transform policies to have required id field for SortableTable
  const formattedPolicies = policies.map((policy, index) => ({
    ...policy,
    id: policy.policy_number || `policy-${index}`,
  }));

  const columns = createPolicyTableColumns(onView, onEdit, onDelete, policyLoadingNumber, lobConfigurationsDict);

  return (
    <div className="mt-4">
      <SortableTable
        rows={formattedPolicies}
        columns={columns}
        defaultOrderColumn={0}
        maxHeight="600px"
        order="desc"
        stickyHeader
        emptyStateComponent={<PolicyEmptyState />}
        highlightOnHover
      />
    </div>
  );
};

export default PolicyList;
